export class DynamoDbGlobalSecondaryIndex {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "indexName",
            "baseName": "indexName",
            "type": "string",
            "format": ""
        },
        {
            "name": "keySchema",
            "baseName": "keySchema",
            "type": "Array<DynamoDbIndexKeySchemaElement>",
            "format": ""
        },
        {
            "name": "projection",
            "baseName": "projection",
            "type": "DynamoDbIndexProjection",
            "format": ""
        },
        {
            "name": "onDemandThroughput",
            "baseName": "onDemandThroughput",
            "type": "DynamoDbIndexThroughput",
            "format": ""
        },
        {
            "name": "provisionedThroughput",
            "baseName": "provisionedThroughput",
            "type": "DynamoDbIndexThroughput",
            "format": ""
        },
        {
            "name": "warmThroughput",
            "baseName": "warmThroughput",
            "type": "DynamoDbIndexThroughput",
            "format": ""
        },
        {
            "name": "indexSizeBytes",
            "baseName": "indexSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbGlobalSecondaryIndex.attributeTypeMap;
    }
    constructor() {
    }
}
